import DetailsPageListItem from 'dashboard/marketplace/DetailsPageListItem';
import { FocusTemplateDetailsListType } from 'enums';
import { t } from 'services/i18n.service';
import { useAppSelectorShallow } from 'store/hooks';

const FocusTemplatePreviewBody = () => {
  const currentViewedFocusTemplate = useAppSelectorShallow(
    (state) => state.focusMode.currentViewedFocusTemplate
  );

  if (!currentViewedFocusTemplate) {
    return null;
  }

  return (
    <div className='w-full flex flex-col gap-6'>
      <DetailsPageListItem
        type={FocusTemplateDetailsListType.ALLOWED_APPS}
        title={t('focus_mode.allowed_apps')}
        allowed_list={currentViewedFocusTemplate.allowed_apps ?? []}
      />
      <DetailsPageListItem
        type={FocusTemplateDetailsListType.ALLOWED_URLS}
        title={t('title_allowed_url')}
        allowed_list={currentViewedFocusTemplate.allowed_urls ?? []}
      />
    </div>
  );
};

export default FocusTemplatePreviewBody;
